import { RECEIVED_POSTS_SUCCESSFULLY, RECEIVED_POSTS_UNSUCCESSFULLY, REQUEST_POSTS } from './feedPage.actions';
import { Section, Article } from '../template.state.types';

export interface FeedPageState {
    topSection: Section
    feedSection: Section
}

export type SectionNames = 'topSection' | 'feedSection';

interface ReceivedPostsSuccessfullyAction {
    type: typeof RECEIVED_POSTS_SUCCESSFULLY
    sectionKey: SectionNames
    articles: Array<Article>
    next: string
}

interface ReceivedPostsUnsuccessfullyAction {
    type: typeof RECEIVED_POSTS_UNSUCCESSFULLY
}

interface RequestPostsAction {
    type: typeof REQUEST_POSTS
}

export type FeedPageAction = ReceivedPostsSuccessfullyAction | ReceivedPostsUnsuccessfullyAction | RequestPostsAction;

export const feedPageReducer = (state:FeedPageState = {} as FeedPageState, action:FeedPageAction) => {
  switch (action.type) {
    case RECEIVED_POSTS_SUCCESSFULLY: {
      return {
        ...state,
        [action.sectionKey]: {
          ...state[action.sectionKey],
          articles: [
            ...state[action.sectionKey].articles,
            ...action.articles,
          ],
          next: action.next,
        },
      };
    }
    case RECEIVED_POSTS_UNSUCCESSFULLY: {
      return state;
    }

    case REQUEST_POSTS: {
      return state;
    }
    default:
      return state;
  }
};
